import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import type { IDepsDesktop, TPropsDesktop } from '../models';
import { Text as Component } from '../text';
import styles from '../styles/styles.css';
import { fontViewsDesktop } from '../config';

export const TextDesktop = createWidget<IDepsDesktop, TPropsDesktop>({
    styles,
    fontViews: fontViewsDesktop,
})(Component);
